import { getTemplates } from '../../services/data-entry/templates.service';

//Assessment Templates
export const UPDATE_ASSESSMENT_TEMPLATE_LIST = 'UPDATE_ASSESSMENT_TEMPLATE_LIST';
export const TOGGLE_ASSESSMENT_TEMPLATE_LIST_LOADING = 'TOGGLE_ASSESSMENT_TEMPLATE_LIST_LOADING';
export const TEMPLATE_ASSESSMENT_LIST_ERROR = 'TEMPLATE_ASSESSMENT_LIST_ERROR';
export const TEMPLATE_ASSESSMENT_UPDATE_TOTAL_LIST = 'TEMPLATE_ASSESSMENT_UPDATE_TOTAL_LIST';
export const TEMPLATE_ASSESSMENT_EXPORT_CHECKED_IDS = 'TEMPLATE_ASSESSMENT_EXPORT_CHECKED_IDS';

export const updateAssessmentTemplateList = (value = []) => ({
  type: UPDATE_ASSESSMENT_TEMPLATE_LIST,
  payload: { name: 'list', value }
});

export const assessmentTemplateListError = (value = null) => ({
  type: TEMPLATE_ASSESSMENT_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingAssessmentTemplates = (value = false) => ({
  type: TOGGLE_ASSESSMENT_TEMPLATE_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const updateAssessmentTemplatesTotalList = (value = 0) => ({
  type: TEMPLATE_ASSESSMENT_UPDATE_TOTAL_LIST,
  payload: { value }
});

export const checkedTemplateIds = (ids = []) => ({
  type: TEMPLATE_ASSESSMENT_EXPORT_CHECKED_IDS,
  ids
});

//Assessments list
export const UPDATE_ASSESSMENTS_LIST = 'UPDATE_ASSESSMENTS_LIST';
export const TOGGLE_ASSESSMENTS_LIST_LOADING = 'TOGGLE_ASSESSMENTS_LIST_LOADING';
export const ASSESSMENTS_LIST_ERROR = 'ASSESSMENTS_LIST_ERROR';

export const updateAssessmentsList = (value = []) => ({
  type: UPDATE_ASSESSMENTS_LIST,
  payload: { name: 'list', value }
});

export const assessmentsListError = (value = null) => ({
  type: ASSESSMENTS_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingAssessments = (value = false) => ({
  type: TOGGLE_ASSESSMENTS_LIST_LOADING,
  payload: { name: 'loading', value }
});

/* Assessments */
export const loadAssessmentTemplateData = (
  skip = 0,
  limit = 50,
  filter,
  type = 'assessment',
  active = true
) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingAssessmentTemplates(true));
      dispatch(assessmentTemplateListError());

      const newFilter = { ...filter, yearLevel: filter?.yearLevel?.filter((item) => item !== 'all') };
      const { data } = await getTemplates(skip, limit, newFilter, type, active);

      if (data) {
        dispatch(updateAssessmentTemplateList(data?.paginatedResults ?? []));
        dispatch(updateAssessmentTemplatesTotalList(data?.totalRecords ?? 0));
        return;
      } else {
        dispatch(updateAssessmentTemplateList([]));
        dispatch(updateAssessmentTemplatesTotalList(0));
      }
    } catch (error) {
      dispatch(updateAssessmentTemplateList([]));
      dispatch(updateAssessmentTemplatesTotalList(0));
    } finally {
      dispatch(assessmentTemplateListError());
      dispatch(toggleLoadingAssessmentTemplates());
    }
  };
};
